import { Link } from "react-router-dom";
import { C } from "../constants";
import { Sec, STitle, Btn, ContentBlock } from "../components/Shared";

export default function ForApprovers() {
  return (
    <div>
      <Sec>
        <STitle tag="For Approvers" title="Your role as an Approver" sub="As an approver, you're the gatekeeper. Here's what that means." />

        <div style={{ maxWidth: 720, margin: "0 auto" }}>
          <ContentBlock icon="🔑" title="What is an Approver?">
            <p style={{ margin: "0 0 10px" }}>An approver is a trusted adult who takes responsibility for overseeing another person's messaging on SafeZapp.</p>
            <p style={{ margin: 0 }}>When you accept a link with a user, you confirm their age bracket and declare your relationship. This isn't just a formality — it's how SafeZapp ensures every user has a real, accountable adult in their corner.</p>
          </ContentBlock>

          <ContentBlock icon="📊" title="Your Dashboard">
            <p style={{ margin: "0 0 10px" }}>From your approver dashboard, you can:</p>
            <p style={{ margin: 0 }}>
              See all linked users and their contacts. Approve or reject new contact requests. Manage notification preferences. View conversation activity and wellbeing insights.
            </p>
          </ContentBlock>

          <ContentBlock icon="🔔" title="Notifications & Alerts">
            <p style={{ margin: 0 }}>You'll receive push notifications when a new link request comes in, when a new contact request needs your approval, and for important account events. Push notifications are only activated after a user is linked to you — this is part of our data minimisation approach.</p>
          </ContentBlock>

          <ContentBlock icon="👥" title="Managing Multiple Users">
            <p style={{ margin: 0 }}>You can link with multiple users from a single approver account. Each user has their own individual settings, contacts, and activity history. Generate a separate pairing code for each person you want to link.</p>
          </ContentBlock>

          <ContentBlock icon="🛡️" title="Your Responsibilities">
            <p style={{ margin: "0 0 10px" }}>By accepting a link, you're confirming that:</p>
            <p style={{ margin: 0 }}>
              You are a guardian, carer, or trusted adult with a genuine relationship to the person you're supervising. The age bracket you declare is accurate to the best of your knowledge. You will respond to contact requests in a timely manner.
            </p>
          </ContentBlock>

          <div style={{ textAlign: "center", marginTop: 36 }}>
            <Link to="/how-it-works"><Btn primary>See the full setup guide →</Btn></Link>
          </div>
        </div>
      </Sec>
    </div>
  );
}
